import service from '@/service'
/**
 *
 * @param {{product:string,supplierName:string}} params
 * @description 获取平均价
 */
export function getAveragePurchasePrice(params) {
  return service['api-scm']({
    url: '/public/purchase/save/getAveragePurchasePrice',
    method: 'get',
    params
  })
}
/**
 * @param {{product:string,supplierName:string}} params
 * @description 获取含税采购价
 */
export function getRecommendPrice(params) {
  return service['api-scm']({
    url: '/public/purchase/getRecommendPrice',
    method: 'get',
    params
  })
}
/**
 * @param {string} codeList
 */
export function getLogisticItemsByCodes(codeList) {
  return service['api-scm']({
    url: '/public/logistics/getCodeAndNameMapByCodeList',
    method: 'get',
    params: { codeList }
  })
}

/**
 * 获取所有的省市区地址
 * @param {*} params
 */
export function getAllGeographicCoordinates(params) {
  return service['api-scm']({
    url: '/public/order/getAllGeographicCoordinates',
    method: 'get',
    params
  })
}

/**
 * @param {{rejectReqQOList:Array<{id:string,taskId:string,assignee?:string,remarks?:string}>,rejectTypeEnum:string}} data
 * @description 批量驳回
 */
export function activitiReject(data) {
  return service['api-scm']({
    url: '/public/activiti/batchReject',
    method: 'post',
    data
  })
}

/**
 * @description 查询订单信息 代办悬浮框用
 */
export function findOrderAgentListByCode(params) {
  return service['api-scm']({
    url: '/public/order/findOrderAgentListByCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 检测是否有人正在编辑详情页
 * @param {{documentType: string, lockCode: string}} data
 * @returns {{code: 200 | 500, msg: string}}}
 */
export function lock(data) {
  return service['api-scm']({
    url: '/public/concurrence/lock',
    method: 'post',
    data
  })
}

/**
 * @description 退出编辑详情页
 * @param {{documentType: string, lockCode: string}} data
 * @returns {{code: 200 | 500, msg: string}}}
 */
export function unlock(data) {
  return service['api-scm']({
    url: '/public/concurrence/unlock',
    method: 'post',
    data
  })
}

/**
 * @description 修改排序
 * @param {{field: string, orderType: string, sort:排序规则 0-正序 1-倒序}} data
 * @returns {{code: 200 | 500, msg: string}}}
 */
export function modifyOrderSort(data) {
  return service['api-scm']({
    url: '/public/order/modifyOrderSort',
    method: 'post',
    data
  })
}

/**
 * @description 获取排序
 * @param {{orderType：ORDER_SEPARATE,ORDER_CONFIRM}} data
 * @returns {{code: 200 | 500, msg: string}}}
 */
export function getOrderSort(params) {
  return service['api-scm']({
    url: '/public/order/getOrderSort',
    method: 'get',
    params
  })
}

/**
 *
 * @description 原料辅助申请单下推采购订单校验
 */
export function validatePushDown(data) {
  return service['api-scm']({
    url: '/public/purchase/validatePushDown',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/* @param {{typeEnum: string,userId: string}} params
 */
export async function getDynamicHeader({ typeEnum, userId }) {
  const response = await service['api-scm']({
    crypt: { type: 'none' },
    url: '/allPublic/getDynamicHead/' + typeEnum,
    method: 'post',
    data: userId
  })

  let data = response?.data

  if (data) {
    data = JSON.parse(data)
  }

  return Promise.resolve({ ...(response ?? {}), data })
}

/**
 * @param {{documentType: string, headJson: string, userId: string}} data
 */
export function updateDynamicHeader({ headJson, ...rest }) {
  return service['api-scm']({
    crypt: { type: 'none' },
    url: '/allPublic/updateDynamicHead',
    method: 'post',
    data: {
      ...rest,
      headJson: JSON.stringify(headJson)
    }
  })
}

/**
 * 获取已审核、未作废的销售订单
 */
export function getAuditedAndNoCancelList(params) {
  return service['api-scm']({
    url: '/public/order/getAuditedAndNoCancelList',
    method: 'get',
    params
  })
}

/**
 * 判断当前订单是否存在
 */
export function checkOrderIsExist(params) {
  return service['api-scm']({
    url: '/public/order/checkOrderIsExist',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export function solvePasteAddress(data) {
  return service['api-scm']({
    url: '/public/order/solvePasteAddress',
    method: 'post',
    data
  })
}
/**
 * 根据采购单号查询出可以下推的销售订单单号
 */
export function queryOrderCodeByPurchaseCode(params) {
  return service['api-scm']({
    url: '/public/logistics/queryOrderCodeByPurchaseCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 根据仓库编码和销售单号查询收货人信息
 */
export function queryAddressByWarehouseCode(params) {
  return service['api-scm']({
    url: '/public/logistics/queryAddressByWarehouseCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 根据采购订单和销售订单查询明细
 */
export function findProductInfoByPurchaseAndOrderCode(params) {
  return service['api-scm']({
    url: '/public/logistics/findProductInfoByPurchaseAndOrderCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
// 自定义查询方案
export function getCustomQuery(data) {
  return service['api-scm']({
    url: '/public/cqs/getSolutionJson',
    method: 'post',
    data
  })
}

// 新增or编辑
export function addCustomQuery(data) {
  return service['api-scm']({
    url: '/public/cqs/saveOrUpdate',
    method: 'post',
    data
  })
}

// 删除
export function deleteCustomQuery(data) {
  return service['api-scm']({
    url: '/public/cqs/deleteSolution',
    method: 'post',
    data
  })
}

// 设置默认方案

export function setDefaultCustomQuery(data) {
  return service['api-scm']({
    url: '/public/cqs/setUpDefault',
    method: 'put',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 根据订单（工小达订单）查询承运商推荐信息
 */
export function queryGxdCarrierPerform(params) {
  return service['api-scm']({
    url: '/public/logistics/queryGxdCarrierPerform',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * 查询待确认的包裹
 */
export function getOrderSeparateDetail(data) {
  return service['api-scm']({
    url: '/public/order/getOrderSeparateDetail',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}
/* @param {{typeEnum: string,userId: string}} params
 */
export async function getDynamicHeaderNew({ typeEnum, userId }) {
  return service['api-scm']({
    crypt: { type: 'none' },
    url: '/allPublic/getDynamicHead/' + typeEnum,
    method: 'post',
    data: userId
  })
}

/**
 * @param {{documentType: string, headJson: string, userId: string}} data
 */
export function updateDynamicHeaderNew({ headJson, ...rest }) {
  return service['api-scm']({
    crypt: { type: 'none' },
    url: '/allPublic/updateDynamicHead',
    method: 'post',
    data: {
      ...rest,
      headJson: JSON.stringify(headJson)
    }
  })
}

// 获取签收确认单
export function downloadPurchaseOrderFile(data) {
  return service['api-scm']({
    url: '/scm/purchase/purchaseInformation/downloadPurchaseOrderFile',
    method: 'post',
    data,
    responseType: 'blob', // 文件流接收类型声明转成 blob
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 拒收工作台日志
export function getRejectLog(params) {
  return service['api-scm']({
    url: '/public/purchase/getRejectLog',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 关联销售订单
export function getOrderSeparateProduct(data) {
  return service['api-scm']({
    url: '/public/order/getOrderSeparateProduct',
    method: 'post',
    data
  })
}

/**
 * @see #4621
 * @param {AvailableNumberDTO} data 入参：{ productCodes: Array<string> }
 * @description 批量查询「9仓剩余可用量合计」
 * @returns {Promise<{code:number,data:Array<NineWarehouseAvailableVO>}>}
 * NineWarehouseAvailableVO：{ productCode:string, availableSum:number }
 *
 * ⚠️ allPublic 接口：网关白名单，既不鉴权也不加解密
 * - 请求直接发明文 JSON，不能包成 { p: '...' }
 * - 响应直接按明文 JSON 解析，不能再走 decrypt()
 */
export function getNineWarehouseAvailableSum(data) {
  return service['api-scm']({
    crypt: { type: 'none' },
    url: '/allPublic/inventory/getNineWarehouseAvailableSum',
    method: 'post',
    data
  })
}

/**
 * @see #4621
 * @param {NineWarehouseStockQO} data 入参：{ productCode:string }
 * @description 查询单个商品「9仓库存明细」(每个仓库一行)
 * @returns {Promise<{code:number,data:Array<NineWarehouseStockVO>}>}
 * NineWarehouseStockVO：{
 *  warehouseCode:string,
 *  warehouseName:string,
 *  inventoryNumber:number,
 *  availableNumber:number,
 *  lockNum:number,
 *  orderUsingNumber:number,
 *  defectiveNumber:number
 * }
 *
 * ⚠️ allPublic 接口：网关白名单，既不鉴权也不加解密，同上
 */
export function getNineWarehouseStockDetail(data) {
  return service['api-scm']({
    crypt: { type: 'none' },
    url: '/allPublic/inventory/getNineWarehouseStockDetail',
    method: 'post',
    data
  })
}
